<template>
  <div class="page-content work-info">
    <div class="page-tit tit">
      <div class="item clr-g">个人信息</div>
      <div class="arrow">
        <svg viewBox="0 0 1035 1024" width="12" height="16">
          <path
            d="M530.850448 573.163313c32.005172-31.883636 32.111192-87.434343-0.069818-119.489939C399.437114 322.845737 268.507336 191.603071 137.436629 60.506505c-12.621576-12.625455-27.585939-20.686869-45.26804-23.540364-3.529697-0.570182-7.085253-0.999434-10.630465-1.499798-1.025293 0-2.055758 0-3.081051 0-4.035232 0.575354-8.111838 0.943838-12.091475 1.757091-33.298101 6.818909-54.838303 26.616242-63.959919 59.278222-3.201293 11.479919-2.806949 24.85398-1.135192 35.701657 1.751919 11.344162 7.11499 21.818182 14.479515 30.904889 3.444364 4.252444 7.050343 8.418263 10.918788 12.291879 111.045818 111.127273 222.142061 222.222222 333.247354 333.293899 1.444202 1.444202 3.227152 2.554828 5.187232 4.080485-2.121697 2.222545-3.475394 3.696485-4.879515 5.100606C252.653437 625.450667 145.164468 733.112889 37.416912 840.506182c-15.829333 15.773737-33.541172 31.162182-36.146424 54.273293-1.233455 10.908444-1.859232 22.111677 0 32.929616 0.919273 5.363071 3.262061 10.423596 5.494949 15.358707 23.655434 52.318384 89.514667 64.241778 130.66602 23.186101C268.668953 835.315071 399.501761 703.987071 530.850448 573.163313L530.850448 573.163313zM78.451902 35.466343l-12.091475 1.757091C70.345235 36.410182 74.421841 36.041697 78.451902 35.466343L78.451902 35.466343zM551.467498 36.441212c-38.000485 2.858667-70.434909 37.034667-71.651556 75.106263-0.79903 24.979394 8.131232 45.650747 25.691798 63.197091 111.383273 111.252687 222.661818 222.615273 334.015354 333.893818 1.534707 1.534707 3.686141 2.448808 6.595232 4.327434-3.35903 2.667313-5.116121 3.803798-6.565495 5.253172-68.050747 68.000323-136.075636 136.035556-204.100525 204.065616C591.916791 765.814949 548.391619 809.360808 504.845761 852.880808c-19.449535 19.439192-28.328081 42.706747-24.045899 70.054788 4.829091 30.919111 22.440081 52.516202 51.712 63.010909 29.450343 10.550303 56.692364 4.803232 80.49002-15.848727 1.944566-1.682101 3.798626-3.470222 5.616485-5.288081 130.121697-130.111354 259.955071-260.509737 390.546101-390.141414 33.272242-33.035636 33.454545-88.934141 1.206303-121.050505C879.016912 322.804364 748.093599 191.557818 617.028064 60.456081c-12.626747-12.626747-27.611798-20.655838-45.288727-23.505455-3.534869-0.570182-7.090424-0.994263-10.635636-1.484283-1.030465 0-2.055758 0-3.086222 0.005172C555.835013 35.799919 553.659013 36.274424 551.467498 36.441212L551.467498 36.441212zM551.467498 36.441212"
            fill="#666"
          ></path>
        </svg>
      </div>
      <div class="item clr-b">工作信息</div>
      <div class="arrow">
        <svg viewBox="0 0 1035 1024" width="12" height="16">
          <path
            d="M530.850448 573.163313c32.005172-31.883636 32.111192-87.434343-0.069818-119.489939C399.437114 322.845737 268.507336 191.603071 137.436629 60.506505c-12.621576-12.625455-27.585939-20.686869-45.26804-23.540364-3.529697-0.570182-7.085253-0.999434-10.630465-1.499798-1.025293 0-2.055758 0-3.081051 0-4.035232 0.575354-8.111838 0.943838-12.091475 1.757091-33.298101 6.818909-54.838303 26.616242-63.959919 59.278222-3.201293 11.479919-2.806949 24.85398-1.135192 35.701657 1.751919 11.344162 7.11499 21.818182 14.479515 30.904889 3.444364 4.252444 7.050343 8.418263 10.918788 12.291879 111.045818 111.127273 222.142061 222.222222 333.247354 333.293899 1.444202 1.444202 3.227152 2.554828 5.187232 4.080485-2.121697 2.222545-3.475394 3.696485-4.879515 5.100606C252.653437 625.450667 145.164468 733.112889 37.416912 840.506182c-15.829333 15.773737-33.541172 31.162182-36.146424 54.273293-1.233455 10.908444-1.859232 22.111677 0 32.929616 0.919273 5.363071 3.262061 10.423596 5.494949 15.358707 23.655434 52.318384 89.514667 64.241778 130.66602 23.186101C268.668953 835.315071 399.501761 703.987071 530.850448 573.163313L530.850448 573.163313zM78.451902 35.466343l-12.091475 1.757091C70.345235 36.410182 74.421841 36.041697 78.451902 35.466343L78.451902 35.466343zM551.467498 36.441212c-38.000485 2.858667-70.434909 37.034667-71.651556 75.106263-0.79903 24.979394 8.131232 45.650747 25.691798 63.197091 111.383273 111.252687 222.661818 222.615273 334.015354 333.893818 1.534707 1.534707 3.686141 2.448808 6.595232 4.327434-3.35903 2.667313-5.116121 3.803798-6.565495 5.253172-68.050747 68.000323-136.075636 136.035556-204.100525 204.065616C591.916791 765.814949 548.391619 809.360808 504.845761 852.880808c-19.449535 19.439192-28.328081 42.706747-24.045899 70.054788 4.829091 30.919111 22.440081 52.516202 51.712 63.010909 29.450343 10.550303 56.692364 4.803232 80.49002-15.848727 1.944566-1.682101 3.798626-3.470222 5.616485-5.288081 130.121697-130.111354 259.955071-260.509737 390.546101-390.141414 33.272242-33.035636 33.454545-88.934141 1.206303-121.050505C879.016912 322.804364 748.093599 191.557818 617.028064 60.456081c-12.626747-12.626747-27.611798-20.655838-45.288727-23.505455-3.534869-0.570182-7.090424-0.994263-10.635636-1.484283-1.030465 0-2.055758 0-3.086222 0.005172C555.835013 35.799919 553.659013 36.274424 551.467498 36.441212L551.467498 36.441212zM551.467498 36.441212"
            fill="#666"
          ></path>
        </svg>
      </div>
      <div class="item">联系人</div>
    </div>
    <div class="page-form content">
      <Form
        use-cache
        form-key="form-work"
        :ref="`form-work`"
        :defaultForm.sync="form"
        :fields="fields"
        :defaultText.sync="fieldTexts"
      >
        <van-field
          slot="field-custom-workUnit"
          v-model.trim="form.workUnit"
          label="公司名称"
          :placeholder="'上传识别或输入公司名称'"
          input-align="right"
          :rules="required"
          required
          @change="setContacts1Name"
        >
          <template #right-icon v-if="form.employmentType == '1'">
            <ImgIcon :size="28" color="#4191f9" @click="openIdcarOcr" />
          </template>
        </van-field>
      </Form>
    </div>

    <div class="page-btn btns">
      <van-button type="info" size="small" @click="nextFn">下一步</van-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { uploadFile } from "@/api/upload";
import {
  createWorkInfo,
  getWorkInfo,
  orderDetailInfo,
  ocrLicence
} from "@/api/apply";
import { getSomeEnums } from "@/api/enums";
import { setFormData } from "../dev_form_json";
import { isImage, isJPG, imageToJPG } from "@/utils/upload-tool.js";
export default {
  components: {
    Form: () => import("@/components/Form/Index"),
    ImgIcon: () => import("@/components/ImgIcon.vue")
  },
  data() {
    return {
      required: [
        {
          required: true
        }
      ],
      bizNo: "",
      applyAmount: 0,
      enums: {},
      form: {},
      fieldTexts: {}
    };
  },
  computed: {
    fields() {
      return [
        {
          type: "select",
          label: "雇佣类型",
          required: true,
          key: "employmentType",
          enums: this.enums?.employmentType || []
        },
        {
          type: "custom",
          label: "公司名称",
          required: true,
          key: "workUnit"
        },
        // {
        //   type: "text",
        //   label: "统一信用代码",
        //   labelWidth: "8em",
        //   required: true,
        //   key: "liceId",
        //   // disabled: true
        // },
        // {
        //   type: "date",
        //   label: "企业成立日期",
        //   key: "establishingDate",
        //   required: true,
        //   // disabled: true
        // },
        // {
        //   type: "text",
        //   label: "法人",
        //   required: true,
        //   // disabled: true,
        //   key: "legalPerson"
        // },
        ...(this.form.employmentType == "1"
          ? [
              {
                type: "text",
                label: "统一信用代码",
                labelWidth: "8em",
                required: true,
                key: "liceId",
                validator: (v) => {
                  const reg =
                    /^(([0-9A-Za-z]{15})|([0-9A-Za-z]{18})|([0-9A-Za-z]{20}))$/;
                  if (v && !reg.test(v)) throw "请输入正确的统一信用代码";
                  else return true;
                }
                // disabled: true
              },
              {
                type: "date",
                label: "企业成立日期",
                key: "establishingDate",
                required: true
                // disabled: true
              },
              {
                type: "text",
                label: "法人",
                required: true,
                key: "legalPerson"
                // disabled: true,
              }
            ]
          : []),
        {
          type: "select",
          label: "公司性质",
          required: true,
          key: "brtype",
          enums: this.enums?.companyProperty || []
        },
        {
          type: "text",
          label: "所属部门",
          required: true,
          key: "deptName"
        },
        // {
        //   type: "select",
        //   label: "公司员工规模",
        //   labelWidth: "7.2em",
        //   required: true,
        //   key: "staffSize",
        //   enums: this.enums?.staffSize || []
        // },
        // {
        //   type: "select",
        //   label: "职称",
        //   required: true,
        //   key: "techTitle",
        //   enums: this.enums?.workTitle || []
        // },
        {
          type: "select",
          label: "职位",
          required: true,
          key: "duty",
          enums: this.enums?.profession || []
        },
        // {
        //   type: "select",
        //   label: "工作性质",
        //   required: true,
        //   key: "workNature",
        //   enums: this.enums?.workNature || []
        // },
        // {
        //   type: "date",
        //   label: "入职时间",
        //   required: true,
        //   key: "entryTime"
        // },
        // {
        //   type: "select",
        //   label: "在职年限",
        //   required: true,
        //   key: "workYears",
        //   enums: this.enums?.serveDuration || []
        // },
        {
          type: "select",
          label: "是否参加社保",
          labelWidth: "7.8em",
          required: true,
          key: "isSocialInsurance",
          enums: [
            {
              text: "是",
              value: "1"
            },
            {
              text: "否",
              value: "2"
            }
          ]
        },
        {
          type: "region",
          label: "单位地址",
          required: true,
          key: "pcrcode",
          keys: ["provinceCode", "cityCode", "regionCode"],
          namesKey: ["provinceName", "cityName", "regionName"]
        },
        {
          type: "textarea",
          label: "详细地址",
          required: true,

          placeholder: "请输入详细地址(需具体到门牌号)",
          key: "unitAddress"
        }
        // {
        //   type: "amount",
        //   label: "个人年收入(万元)",
        //   labelWidth: "7.8em",
        //   required: true,
        //   decimal: 2,
        //   key: "annualIncome",
        //   blur: (v) => {
        //     const { annualHouseholdIncome } = this.form;
        //     if (v && annualHouseholdIncome && +v > +annualHouseholdIncome) {
        //       this.$errMsg("个人年收入不能大于家庭年收入");
        //     } else {
        //       this.$toast.clear();
        //     }
        //   },
        //   validator: (v) => {
        //     const { annualHouseholdIncome } = this.form;
        //     if (v && annualHouseholdIncome && +v > +annualHouseholdIncome) {
        //       throw "个人年收入不能大于家庭年收入";
        //     } else return true;
        //   }
        // },
        // {
        //   type: "amount",
        //   label: "家庭年收入(万元)",
        //   labelWidth: "7.8em",
        //   decimal: 2,
        //   required: true,
        //   key: "annualHouseholdIncome",
        //   blur: (v) => {
        //     const { annualIncome } = this.form;
        //     if (annualIncome && v && +annualIncome > +v) {
        //       this.$errMsg("个人年收入不能大于家庭年收入");
        //     } else if (+v > 1000) {
        //       this.$errMsg("家庭年收入不能大于1000万");
        //     } else {
        //       this.$toast.clear();
        //     }
        //   },
        //   validator: (v) => {
        //     const { annualIncome } = this.form;
        //     if (annualIncome && v && +annualIncome > +v) {
        //       throw "个人年收入不能大于家庭年收入";
        //     } else if (+v > 1000) {
        //       throw "家庭年收入不能大于1000万";
        //     } else return true;
        //   }
        // },
        // {
        //   type: "select",
        //   label: "是否个体工商户",
        //   labelWidth: "7.8em",
        //   required: true,
        //   key: "selfEmployed",
        //   enums: [
        //     {
        //       text: "是",
        //       value: "Y"
        //     },
        //     {
        //       text: "否",
        //       value: "N"
        //     }
        //   ]
        // }
      ];
    }
  },
  mounted() {
    this.init();
    this.getAllEnums();
    window.agilityAutoFill = this.agilityAutoFill;
  },
  methods: {
    ...mapGetters(["getUserOrderInfo"]),
    init() {
      const data = this.getUserOrderInfo();
      this.bizNo = data.bizNo || "";
      this.getApplyInfo();
      this.getWorkInfo();
    },
    async getWorkInfo() {
      try {
        this.$toast.loading({
          forbidClick: true,
          duration: 0
        });
        const { data } = await getWorkInfo(this.bizNo);
        this.$set(this, "form", data || {});
        this.$set(this.form, "pcrcode", data?.regionCode || "");
        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      }
    },
    // 申请信息
    async getApplyInfo() {
      try {
        this.$toast.loading({
          forbidClick: true,
          duration: 0
        });
        const { data } = await orderDetailInfo(this.bizNo);
        this.applyAmount = data?.applyAmount || 0;
        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async getAllEnums() {
      try {
        const [d1, d2, d4, d6] = await Promise.all([
          getSomeEnums("companyProperty"),
          getSomeEnums("employmentType"),
          getSomeEnums("profession"),
          getSomeEnums("workTitle")
        ]);
        this.$set(this.enums, "companyProperty", d1);
        this.$set(this.enums, "employmentType", d2);
        this.$set(this.enums, "profession", d4);
        this.$set(this.enums, "workTitle", d6);
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async nextFn() {
      try {
        const infodom = this.$refs["form-work"];
        await infodom.validate();
        const params = {
          bizNo: this.bizNo,
          ...this.form
        };
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          duration: 0
        });
        await createWorkInfo(params);
        this.$toast.clear();
        this.$router.push("/contact-info");
      } catch (error) {
        this.$errMsg(error);
      }
    },
    // 开发快速调试
    agilityAutoFill() {
      let isdev = process.env.NODE_ENV === "development";
      if (isdev) {
        setFormData(this, "form", "apply_form_data_works_form");
      }
    },
    setContacts1Name() {
      this.$set(this.form, "workUnit", this.form.workUnit);
    },
    // 营业执照识别
    async openIdcarOcr() {
      try {
        const ossAccessUrl = await this.uploadUseInput();
        this.$toast.loading({
          message: "图片识别中...",
          forbidClick: true,
          duration: 0
        });
        const { data } = await ocrLicence({
          fileUrl: ossAccessUrl
        });
        this.$set(this.form, "workUnit", data.enterpriseName || "");
        this.$set(this.form, "liceId", data.creditCode || "");
        this.$set(this.form, "legalPerson", data.legalName || "");
        this.$set(this.form, "establishingDate", data.establishingDate || "");
        this.$set(this.form, "licenceUrl", ossAccessUrl);
        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async uploadUseInput() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.click();

      return new Promise((resp) => {
        input.onchange = async () => {
          this.$toast.loading({
            message: "图片上传中...",
            forbidClick: true,
            duration: 0
          });
          let file = input.files[0];
          let name = file.name;
          if (!isImage(name)) return this.$errMsg("请选择JPG格式的图片文件");
          if (!isJPG(name)) {
            file = await imageToJPG(file);
          }
          const { ossAccessUrl } = await uploadFile(file);
          return resp(ossAccessUrl);
        };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./input-style.scss";
.work-info {
  .tit {
    display: flex;
    height: 88px;
    border-bottom: 1px solid #eee;
    & > * {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .arrow {
      flex: 1;
    }
    .item {
      color: #666;
      width: 45%;
      font-size: 32px;
      font-weight: bold;
    }
  }
  .btns {
    .van-button {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
